import React, { useEffect } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorContainer from '../../components/error-boundary/index';
import Head from 'next/head';
import LandingPageFooter from '../../components/Landing/footer';
import LandingPageHeader from '../../components/Landing/header';
import useWindowSize from '../../utils/hooks/use-window-size';
import { useRouter } from 'next/router';
import { LegalPageLayout } from '../../components/Landing/privacy-policy';

const Support = () => {
  const router = useRouter();
  const { width } = useWindowSize();

  useEffect(() => {
    document.documentElement.setAttribute('style', 'scroll-behavior: smooth;');
  });

  return (
    <ErrorBoundary FallbackComponent={ErrorContainer} onReset={() => {}}>
      <Head>
        <meta content="Togather: Church OS for Small Groups, Member Health, Seamless Messaging, and more." property="og:title"/>
        <meta content="https://togather-cdn-production.s3.amazonaws.com/marketing/og_image.png" property="og:image"/>
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@gettogatherco"/>
        <meta name="twitter:title" content="Togather"/>
        <meta name="twitter:description" content="Church OS for Small Groups, Member Health, Seamless Messaging, and more."/>
        <meta name="twitter:image" content="https://togather-cdn-production.s3.amazonaws.com/marketing/og_image.png"/>
      </Head>
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          flexFlow: 'column',
        }}
      >
        <LandingPageHeader
          fixHeader={true}
          showModal={false}
          width={width}
          scrollToPrices={() => router.push('/pricing')}
          offToLandingpage={true}
        />
        <LegalPageLayout
          style={{
            textAlign: 'center',
            flex: '1',
          }}
        >
          <h1>Support</h1>
          <p>For help with your account, or feedback, please reach us at: support@gettogather.co</p>
        </LegalPageLayout>
        <LandingPageFooter
          letterSectionColor={'#FAFAFA'}
        />
      </div>
    </ErrorBoundary>
  );
};

export default Support;
